import React, { useState } from 'react';
import { Nations } from './Nations';
import { IoIosAddCircle as AddIcon } from 'react-icons/io';
import { MdCancel as CancelIcon } from 'react-icons/md';
// import { PiPhoneTransferFill as TransferCallIcon } from 'react-icons/pi';
import { PiPhoneOutgoingFill as TransferCallIcon } from 'react-icons/pi';
import { RiUserReceived2Fill as TransferAgentIcon } from 'react-icons/ri';
import Select from 'react-select';

const buttons = [
  {
    label: 'Trasferimento a Numero',
    icon: <TransferCallIcon />,
  },
  {
    label: 'Trasferimento a Agente',
    icon: <TransferAgentIcon />,
  },
];

const TransferButton = ({ icon, label, isActive, onClick }) => (
  <button
    className={`transfer-to-human btn ${isActive ? 'trasferButtonActive' : ''}`}
    type="button"
    onClick={onClick}
  >
    {icon}
    {label}
  </button>
);

const TransferAssistantToAgent = ({
  phoneAgentConfigurationDetail,
  setPhoneAgentConfigurationDetail,
}) => {
  const rules = phoneAgentConfigurationDetail.transferToAgent || [];

  const addRule = () => {
    const newId =
      rules.length > 0 ? Math.max(...rules.map((r) => r.id)) + 1 : 1;
    const newRules = [...rules, { id: newId, agent: 'none', condition: '' }];
    setPhoneAgentConfigurationDetail({
      ...phoneAgentConfigurationDetail,
      transferToAgent: newRules,
    });
  };

  const removeRule = (id) => {
    const newRules = rules.filter((rule) => rule.id !== id);
    setPhoneAgentConfigurationDetail({
      ...phoneAgentConfigurationDetail,
      transferToAgent: newRules,
    });
  };

  const updateRule = (id, key, value) => {
    const newRules = rules.map((rule) =>
      rule.id === id ? { ...rule, [key]: value } : rule
    );
    setPhoneAgentConfigurationDetail({
      ...phoneAgentConfigurationDetail,
      transferToAgent: newRules,
    });
  };

  return (
    <div className="card my-3 border-0">
      <div className="card-body h-100 phone-agent-card-color rounded-3">
        <label className="form-label font-size-18" htmlFor="titoloProg">
          Trasferisci a agente
        </label>
        <p className="text-muted">
          Configura una o più regole per trasferire le chiamate verso un agente
          specifico...
        </p>

        {rules.length > 0 &&
          rules.map((rule, index) => (
            <div className="card my-3 border-0 shadow" key={rule.id}>
              <div className="card-body rounded-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <label className="form-label font-size-18 m-0">
                    Regola di trasferimento {index + 1}
                  </label>
                  <button
                    className="btn p-0"
                    style={{ fontSize: '25px', color: '#852B2B' }}
                    onClick={() => removeRule(rule.id)}
                  >
                    <CancelIcon />
                  </button>
                </div>

                <label className="form-label">Agente di destinazione</label>
                <div className="mb-3">
                  <Select
                    options={[
                      { value: 'none', label: 'Nessun agente' },
                      ...phoneAgentConfigurationDetail.phoneAgentProjects.map(
                        (agentProject) => ({
                          value: agentProject.elevenLabsAgentCode, // valore inviato al cambio selezione
                          label: agentProject.title, // valore mostrato nel menu
                        })
                      ),
                    ]}
                    value={
                      phoneAgentConfigurationDetail.phoneAgentProjects
                        .map((agentProject) => ({
                          value: agentProject.elevenLabsAgentCode,
                          label: agentProject.title,
                        }))
                        .find((opt) => opt.value === rule.agent) || {
                        value: 'none',
                        label: 'Nessun agente',
                      }
                    }
                    onChange={(selectedOption) => {
                      updateRule(rule.id, 'agent', selectedOption.value);
                    }}
                    classNamePrefix="react-select"
                    isSearchable
                  />
                </div>

                <label className="form-label">
                  Condizione di Trasferimento
                </label>
                <textarea
                  className="form-control"
                  placeholder="Esempio: se l'utente chiede di parlare con il reparto tecnico..."
                  style={{ minHeight: '100px' }}
                  value={rule.condition}
                  onChange={(e) =>
                    updateRule(rule.id, 'condition', e.target.value)
                  }
                />
              </div>
            </div>
          ))}

        <button
          className="btn bg-green-second text-white w-100 py-2 my-4 d-flex gap-1 justify-content-center align-items-center"
          onClick={addRule}
        >
          <AddIcon style={{ fontSize: '25px' }} />
          Aggiungi Regola di Trasferimento
        </button>
      </div>
    </div>
  );
};

const TransferAssistantToNumber = ({
  phoneAgentConfigurationDetail,
  setPhoneAgentConfigurationDetail,
}) => {
  const rules = phoneAgentConfigurationDetail.transferToNumber || [];

  const addRule = () => {
    const newId =
      rules.length > 0 ? Math.max(...rules.map((r) => r.id)) + 1 : 1;
    const newRules = [
      ...rules,
      { id: newId, phoneCode: '+39', phoneNumber: '', condition: '' },
    ];
    setPhoneAgentConfigurationDetail({
      ...phoneAgentConfigurationDetail,
      transferToNumber: newRules,
    });
  };

  const removeRule = (id) => {
    const newRules = rules.filter((rule) => rule.id !== id);
    setPhoneAgentConfigurationDetail({
      ...phoneAgentConfigurationDetail,
      transferToNumber: newRules,
    });
  };

  const updateRule = (id, key, value) => {
    const newRules = rules.map((rule) =>
      rule.id === id ? { ...rule, [key]: value } : rule
    );
    setPhoneAgentConfigurationDetail({
      ...phoneAgentConfigurationDetail,
      transferToNumber: newRules,
    });
  };

  const nationOptions = Nations.map((nation) => ({
    value: nation.phoneCode,
    label: `${nation.flagEmoji} ${nation.name} (${nation.phoneCode})`,
  }));

  return (
    <div className="card my-3 border-0">
      <div className="card-body h-100 phone-agent-card-color rounded-3">
        <label className="form-label font-size-18" htmlFor="titoloProg">
          Trasferisci a numero
        </label>
        <p className="text-muted">
          Configura una o più regole per trasferire le chiamate verso numeri di
          telefono specifici...
        </p>

        {rules.length > 0 &&
          rules.map((rule, index) => (
            <div className="card my-3 border-0 shadow" key={rule.id}>
              <div className="card-body rounded-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <label
                    className="form-label font-size-18 m-0"
                    htmlFor="titoloProg"
                  >
                    Regola di trasferimento {index + 1}
                  </label>
                  <button
                    className="btn p-0"
                    style={{ fontSize: '25px', color: '#852B2B' }}
                    onClick={() => removeRule(rule.id)}
                  >
                    <CancelIcon />
                  </button>
                </div>

                <label className="form-label">Numero di telefono</label>
                <div className="row g-2 mb-3">
                  <div className="col-auto" style={{ flex: '0 0 300px' }}>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      value={nationOptions.find(
                        (opt) => opt.value === rule.phoneCode
                      )}
                      onChange={(selectedOption) =>
                        updateRule(rule.id, 'phoneCode', selectedOption.value)
                      }
                      options={nationOptions}
                      isSearchable={true}
                      placeholder="Seleziona un Paese..."
                    />
                  </div>
                  <div className="col">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Numero di Telefono"
                      value={rule.phoneNumber}
                      onChange={(e) =>
                        updateRule(rule.id, 'phoneNumber', e.target.value)
                      }
                    />
                  </div>
                </div>

                <label className="form-label">
                  Condizione di Trasferimento
                </label>
                <textarea
                  className="form-control"
                  placeholder="Esempio: se l'utente chiede di parlare con un operatore..."
                  style={{ minHeight: '100px' }}
                  value={rule.condition}
                  onChange={(e) =>
                    updateRule(rule.id, 'condition', e.target.value)
                  }
                />
              </div>
            </div>
          ))}

        <button
          className="btn bg-green-second text-white w-100 py-2 my-4 d-flex gap-1 justify-content-center align-items-center"
          onClick={addRule}
        >
          <AddIcon style={{ fontSize: '25px' }} />
          Aggiungi Regola di Trasferimento
        </button>
      </div>
    </div>
  );
};

const TransferAssistant = ({
  phoneAgentConfigurationDetail,
  setPhoneAgentConfigurationDetail,
}) => {
  const [activeButton, setActiveButton] = useState('Trasferimento a Numero');

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid justify-content-evenly">
          {buttons.map((btn, idx) => (
            <TransferButton
              key={idx}
              icon={btn.icon}
              label={btn.label}
              isActive={btn.label === activeButton}
              onClick={() => setActiveButton(btn.label)}
            />
          ))}
        </div>
      </nav>

      {activeButton === 'Trasferimento a Numero' ? (
        <TransferAssistantToNumber
          phoneAgentConfigurationDetail={phoneAgentConfigurationDetail}
          setPhoneAgentConfigurationDetail={setPhoneAgentConfigurationDetail}
        />
      ) : (
        <TransferAssistantToAgent
          phoneAgentConfigurationDetail={phoneAgentConfigurationDetail}
          setPhoneAgentConfigurationDetail={setPhoneAgentConfigurationDetail}
        />
      )}
    </>
  );
};

export default TransferAssistant;
